/* eslint-disable jsx-a11y/click-events-have-key-events */
// Keyboard listener is implemented in MentionableTextInputMenu

import React from "react"
import types from "prop-types"
import clsx from "clsx"

export const MENU_ITEM_IDENTIFYING_ATTRIBUTE = "data-mentionable-text-input-menu-item"

// The list item is given a tabIndex so that when clicked it will be identified
// as the relatedTarget in the MentionableTextInput component's textarea's onBlur
// event handler function.  That function uses MENU_ITEM_IDENTIFYING_ATTRIBUTE
// to identity that the relatedTarget is a menu item and not another element.
const MentionableTextInputMenuItem = ({
  highlighted, label, onClick, onMouseEnter,
}) => (
  <li
    aria-selected={highlighted}
    className={clsx("py-1.5 px-3 rounded cursor-pointer", highlighted && "bg-lightgray")}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    role="option"
    tabIndex={-1}
    {...{ [MENU_ITEM_IDENTIFYING_ATTRIBUTE]: true }}
  >
    <span className="whitespace-nowrap">{label}</span>
  </li>
)

MentionableTextInputMenuItem.propTypes = {
  highlighted: types.bool.isRequired,
  label: types.string.isRequired,
  onClick: types.func.isRequired,
  onMouseEnter: types.func.isRequired,
}

export default MentionableTextInputMenuItem
